import { render, staticRenderFns } from "./start-training-downloads.vue?vue&type=template&id=06062bc9&scoped=true"
import script from "./start-training-downloads.vue?vue&type=script&lang=js"
export * from "./start-training-downloads.vue?vue&type=script&lang=js"
import style0 from "./start-training-downloads.vue?vue&type=style&index=0&id=06062bc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06062bc9",
  null
  
)

export default component.exports